<script>
import ToastListItem from './ToastListItem.vue'

export default {
  components: { ToastListItem },
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
}
</script>
<template>
  <div aria-live="polite" aria-atomic="true">
    <div>
      <ToastListItem v-for="(message, index) of messages" :key="index" :message="message" />
    </div>
  </div>
</template>
